import React from 'react';

function Footer() {

    const currentYear = new Date().getFullYear();

    return (
        <div className="footer">
            <footer>
                <p className="my-name">
                    Made with ❤ by Devesh 
                </p>
                <p>
                    © Copyright {currentYear}
                </p>
               
            </footer>
        </div>
    );
}

export default Footer;